import { motion } from "framer-motion";

const variants = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0 },
};

export const Reveal = ({ children, delay = 0, className = "", ...props }) => (
  <motion.div
    className={className}
    variants={variants}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.5, ease: "easeOut", delay }}
    {...props}
  >
    {children}
  </motion.div>
);
